module.exports = __webpack_public_path__ + "img/light-left.802b09a7.svg";